import { render } from "./FooterSectionTwo.vue?vue&type=template&id=b7ca9a6c"
import script from "./FooterSectionTwo.vue?vue&type=script&lang=js"
export * from "./FooterSectionTwo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__